import { render, staticRenderFns } from "./c-manage-report-content-buttons.vue?vue&type=template&id=3169865b&scoped=true&"
import script from "./c-manage-report-content-buttons.vue?vue&type=script&lang=js&"
export * from "./c-manage-report-content-buttons.vue?vue&type=script&lang=js&"
import style0 from "./c-manage-report-content-buttons.vue?vue&type=style&index=0&id=3169865b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169865b",
  null
  
)

export default component.exports